import { Capacitor } from "@capacitor/core";
import { SecureStorage } from "@aparajita/capacitor-secure-storage";

export interface SecureStore {
  get(key: string): Promise<string | null>;
  set(key: string, value: string): Promise<void>;
  remove(key: string): Promise<void>;
}
const webStore: SecureStore = {
  async get(key) {
    return sessionStorage.getItem(key);
  },
  async set(key, value) {
    sessionStorage.setItem(key, value);
  },
  async remove(key) {
    sessionStorage.removeItem(key);
  },
};
const nativeStore: SecureStore = {
  async get(key) {
    try {
      return (await SecureStorage.get(key)) as string;
    } catch {
      return null;
    }
  },
  async set(key, value) {
    await SecureStorage.set(key, value);
  },
  async remove(key) {
    await SecureStorage.remove(key);
  },
};
export const secureStore = Capacitor.isNativePlatform()
  ? nativeStore
  : webStore;
